var _path, _rect, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconXls = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.414 2H6C4.897 2 4 2.898 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V6.586L15.414 2ZM7 12H15V14H7V12ZM17 18H7V16H17V18ZM14 8V3L19 8H14Z",
    fill: "#008908"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 8,
    fill: "#008908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57972 18V14.3636H10.03V14.9975H8.34854V15.864H9.90394V16.4979H8.34854V17.3661H10.0371V18H7.57972ZM11.3621 14.3636L12.0954 15.603H12.1238L12.8607 14.3636H13.729L12.6192 16.1818L13.7538 18H12.8696L12.1238 16.7589H12.0954L11.3497 18H10.469L11.6072 16.1818L10.4903 14.3636H11.3621ZM14.2155 18V14.3636H14.9843V17.3661H16.5432V18H14.2155Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconXls, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconXLS.1c02f54c.svg";
export { ForwardRef as ReactComponent };